import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaidarshancabs() {



  const cardData = {
    keyword: " Mumbai Darshan Cabs ",


"headingDescription": "Royal Route Cab offers comfortable and convenient Mumbai Darshan cab services, making it easy for tourists and families to explore the city’s most famous attractions in a single day. Our Mumbai Darshan packages are designed to cover all major sightseeing points with professional drivers, clean vehicles, and flexible travel plans for a hassle-free experience. Whether you are visiting Mumbai for the first time or planning a city tour with family and friends, we ensure a smooth journey with doorstep pickup, guided routes, and affordable pricing with no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for solo travelers, couples, and large groups. With easy booking and 24/7 customer support, Royal Route Cab is your trusted choice for Mumbai Darshan cab services.",

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "Gateway of India is Mumbai’s most iconic landmark located on the waterfront of Colaba, built during the British era. It is a major tourist attraction where visitors enjoy ferry rides to Elephanta Caves, photography, street shopping, and views of the Arabian Sea. The surrounding area is always lively with cafes, heritage hotels, and cultural activity."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive is a 3.6 km long coastal boulevard known as the Queen’s Necklace due to its sparkling night lights. It is one of the most peaceful places in Mumbai where people enjoy sunset views, evening walks, street food, and sea breeze along the Arabian Sea."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of the most popular beaches in Mumbai known for its vibrant street food culture, horse rides, and sunset views. It is a favorite weekend spot for locals and tourists looking for relaxation and entertainment along the coastline."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple is a highly revered Hindu temple dedicated to Lord Ganesha, attracting devotees from across India. It is known for its spiritual energy, long queues on Tuesdays, and strong religious importance in Mumbai."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a famous mosque and tomb located on a small island in the Arabian Sea, connected by a narrow walkway. It is known for its peaceful environment and stunning Indo-Islamic architecture."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "Bandra-Worli Sea Link is an engineering marvel connecting Mumbai’s western suburbs with South Mumbai. It offers breathtaking views of the sea, especially at night when the bridge is beautifully illuminated."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus",
    "description": "Chhatrapati Shivaji Maharaj Terminus is a UNESCO World Heritage Site and one of India’s busiest railway stations. It is famous for its Victorian Gothic architecture and historical significance, representing Mumbai’s colonial and modern transport legacy."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is a bustling shopping street filled with street vendors, cafes, fashion stores, and souvenir shops. It is one of the best places in Mumbai for budget shopping and street culture experience."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves are a UNESCO World Heritage Site located on Elephanta Island, featuring ancient rock-cut temples dedicated to Lord Shiva. It is accessible by ferry from Gateway of India and is a major historical attraction."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is a large protected green space within Mumbai offering nature trails, wildlife sightings, and the famous Kanheri Caves. It provides a natural escape from the busy city life."
  }
],






services: [
  {
    name: "Mumbai Darshan Cab",
    description: "Mumbai Darshan cab service offers a comfortable and convenient way to explore the city’s top attractions in a single trip. From iconic landmarks to cultural spots and beaches, this service covers all major destinations. Ideal for tourists, families, and groups, it ensures a relaxed sightseeing experience. Professional drivers guide routes efficiently. Multiple vehicle options are available. It guarantees a memorable Mumbai tour."
  },
  {
    name: "Mumbai Darshan Taxi",
    description: "Mumbai Darshan taxi provides easy and private travel for exploring the city’s famous attractions. This service includes flexible pickup and drop options. Vehicles are clean and driven by experienced drivers familiar with city routes. Ideal for tourists and families. It ensures a smooth sightseeing experience."
  },
  {
    name: "Mumbai Sightseeing Cab",
    description: "Mumbai sightseeing cab is designed for tourists who want to explore popular destinations comfortably. This service covers beaches, temples, monuments, and markets. Flexible travel plans and comfortable vehicles enhance the journey. Professional drivers ensure safe travel. It ensures a hassle-free city tour."
  },
  {
    name: "Mumbai Tour Cab Service",
    description: "Mumbai tour cab service offers complete city tour solutions with customized travel plans. This service is ideal for first-time visitors and group travelers. Vehicles are well-maintained and suitable for full-day tours. Experienced drivers ensure efficient routes. It guarantees a comfortable and enjoyable trip."
  },
  {
    name: "Mumbai Darshan Taxi Service",
    description: "Mumbai Darshan taxi service provides reliable and comfortable transportation for city tours. This service includes pickup, drop, and sightseeing coverage. Clean vehicles and trained drivers ensure a pleasant ride. Flexible schedules add convenience. It ensures a stress-free experience."
  },
  {
    name: "Cab for Mumbai Sightseeing",
    description: "Cab for Mumbai sightseeing offers a private and flexible travel option for exploring the city. Travelers can customize stops and duration based on preferences. This service is ideal for families and small groups. Professional drivers ensure smooth travel. It offers a relaxed city tour."
  },
  {
    name: "Taxi for Mumbai Darshan",
    description: "Taxi for Mumbai Darshan provides convenient and efficient travel for visiting major attractions. Door-to-door pickup and flexible routes enhance convenience. Suitable for tourists and local travelers. It ensures a comfortable and reliable journey."
  },
  {
    name: "Mumbai Local Tour Cab",
    description: "Mumbai local tour cab is perfect for exploring nearby attractions within the city. This service is ideal for short trips and half-day tours. Quick availability and flexible booking options make it convenient. Professional drivers ensure safe travel. It guarantees a smooth experience."
  },
  {
    name: "Mumbai Tourist Cab Service",
    description: "Mumbai tourist cab service offers specialized travel for visitors exploring the city. This service includes guided routes to major landmarks and attractions. Comfortable vehicles and experienced drivers enhance the journey. It ensures a memorable sightseeing experience."
  },
  {
    name: "Mumbai Darshan Cab Booking",
    description: "Mumbai Darshan cab booking allows travelers to reserve their sightseeing cab easily. Customers can choose vehicle type, tour duration, and pickup location. Instant confirmation and transparent pricing ensure a hassle-free process. It simplifies tour planning."
  },
  {
    name: "Mumbai Darshan Taxi Booking Online",
    description: "Mumbai Darshan taxi booking online provides a quick and convenient way to plan your city tour. Customers can compare vehicle options and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures availability during peak seasons."
  },
  {
    name: "Mumbai Darshan Cab Price",
    description: "Mumbai Darshan cab price varies based on vehicle type, tour duration, and route coverage. Transparent pricing ensures no hidden charges. Budget-friendly and premium options are available. It helps travelers plan their sightseeing efficiently. It ensures value for money."
  },
  {
    name: "Mumbai Darshan Taxi Fare",
    description: "Mumbai Darshan taxi fare is designed to be affordable and competitive for city tours. Fare depends on vehicle type and package duration. Customers receive clear pricing details before booking. Multiple options suit different budgets. It ensures cost-effective travel."
  },
  {
    name: "Full Day Mumbai Darshan Cab",
    description: "Full day Mumbai Darshan cab is ideal for exploring all major attractions in a single day. This package includes extended travel time and multiple stops. Suitable for tourists and families. Comfortable vehicles and professional drivers ensure a smooth experience. It guarantees a complete city tour."
  },
  {
    name: "Half Day Mumbai Darshan Taxi",
    description: "Half day Mumbai Darshan taxi is perfect for short sightseeing trips covering key attractions. This service is ideal for travelers with limited time. Flexible routes and quick service enhance convenience. It ensures an efficient and enjoyable tour."
  },
  {
    name: "Mumbai Darshan Innova Cab",
    description: "Mumbai Darshan Innova cab is perfect for families and groups seeking spacious and comfortable travel. The vehicle offers ample seating and luggage space. Ideal for full-day tours. Professional drivers ensure safety. It provides a premium sightseeing experience."
  },
  {
    name: "Mumbai Darshan Sedan Cab",
    description: "Mumbai Darshan sedan cab is ideal for couples and small families seeking economical travel. Sedans offer smooth rides and comfort for city tours. This option is widely preferred for affordability. Professional drivers ensure safe travel. It is perfect for a relaxed journey."
  },
  {
    name: "Best Mumbai Darshan Taxi Service",
    description: "Best Mumbai Darshan taxi service ensures a premium sightseeing experience with top-quality vehicles and professional drivers. This service focuses on comfort, safety, and customer satisfaction. Multiple vehicle options are available. Transparent pricing builds trust. It guarantees a memorable city tour."
  }
],

tableData: [
  ["Mumbai Darshan Cab", "Mumbai Darshan Taxi"],
  ["Mumbai Sightseeing Cab", "Mumbai Tour Cab Service"],
  ["Mumbai Darshan Taxi Service", "Cab for Mumbai Sightseeing"],
  ["Taxi for Mumbai Darshan", "Mumbai Local Tour Cab"],
  ["Mumbai Tourist Cab Service", "Mumbai Darshan Cab Booking"],
  ["Mumbai Darshan Taxi Booking Online", "Mumbai Darshan Cab Price"],
  ["Mumbai Darshan Taxi Fare", "Full Day Mumbai Darshan Cab"],
  ["Half Day Mumbai Darshan Taxi", "Mumbai Darshan Innova Cab"],
  ["Mumbai Darshan Sedan Cab", "Best Mumbai Darshan Taxi Service"]
],


whychoose: [
  {
    WhyChooseheading: "Complete Mumbai Darshan Tour",
    WhyChoosedescription: "Royal Route Cabs offers a well-planned Mumbai Darshan cab service covering all major tourist attractions, religious places, and famous landmarks in the city."
  },
  {
    WhyChooseheading: "Experienced Local Drivers",
    WhyChoosedescription: "Our drivers are well-versed with Mumbai city routes and sightseeing spots, ensuring smooth navigation and a hassle-free tour experience."
  },
  {
    WhyChooseheading: "Customizable Sightseeing Packages",
    WhyChoosedescription: "We provide flexible Mumbai Darshan packages where you can customize the itinerary based on your preferences and time."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs offers clear pricing for Mumbai Darshan tours including driver charges with no hidden costs."
  },
  {
    WhyChooseheading: "Comfortable & Clean Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned for a comfortable sightseeing experience."
  },
  {
    WhyChooseheading: "Half-Day & Full-Day Options",
    WhyChoosedescription: "Choose from half-day or full-day Mumbai Darshan cab packages depending on your travel plan."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for families and group tours."
  },
  {
    WhyChooseheading: "Trusted Mumbai Sightseeing Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by tourists for Mumbai Darshan cab bookings due to reliable service and professional drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai Darshan cab service?", answer: "Yes, Royal Route Cabs offers complete Mumbai Darshan cab packages for sightseeing." },
  { question: "Which places are covered in Mumbai Darshan?", answer: "Popular places include Gateway of India, Marine Drive, Siddhivinayak Temple, Haji Ali Dargah, Juhu Beach, and more." },
  { question: "What is the duration of Mumbai Darshan?", answer: "You can choose half-day (4-5 hours) or full-day (8-10 hours) packages." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai Darshan cab service is available 24/7." },
  { question: "Which vehicles are available for the tour?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I customize the sightseeing plan?", answer: "Yes, we provide fully customizable Mumbai Darshan tour plans." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide hotel pickup?", answer: "Yes, we provide pickup from hotels, homes, and airports anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended, especially during tourist seasons." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Kulkarni",
    feedback: "The Mumbai Darshan tour with Royal Route Cabs was very well organized. We were able to cover all major spots comfortably with a polite and knowledgeable driver.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Desai",
    feedback: "Excellent sightseeing experience in Mumbai. The cab was clean and comfortable, and the whole city tour felt smooth and well-planned with Royal Route Cabs.",
    rating: 5
  }
];
















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Darshan Cabs",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-darshan-cab.jpg", // replace if needed
  "description": "Book Mumbai Darshan cab with Royal Route Cabs for a comfortable sightseeing experience in Mumbai. Choose full-day and half-day tour packages with sedan, SUV, Innova, and luxury cars. Professional drivers for a smooth city tour experience.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2499", // adjust if needed (half/full day package pricing)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-darshan-cabs"
  }
};







  return (
    <div>
<Helmet>
  <title>Mumbai Darshan Cabs | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai Darshan cab with Royal Route Cabs for sightseeing tours. Full-day & half-day Mumbai city tour packages with sedan, SUV, Innova & luxury cars. Safe and comfortable travel."
  />

  <meta
    name="keywords"
    content="mumbai darshan cab, mumbai darshan taxi, mumbai sightseeing cab, mumbai tour cab service, mumbai darshan taxi service, cab for mumbai sightseeing, taxi for mumbai darshan, mumbai local tour cab, mumbai tourist cab service, mumbai darshan cab booking, mumbai darshan taxi booking online, mumbai darshan cab price, mumbai darshan taxi fare, full day mumbai darshan cab, half day mumbai darshan taxi, mumbai darshan innova cab, mumbai darshan sedan cab, best mumbai darshan taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/29.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaidarshancabs;